import { API_ENDPOINTS } from '@/api/endpoints';
import { Area } from '@/stores/SubprojectStore';
import { apiFetch } from '@/util/apiClient';
import { useQuery } from '@tanstack/react-query';
import {
  SpecializedEquipment,
  SpecializedEquipmentWithMetrics,
} from '../types';
import { addMetricsToResource } from './techMetrics';

function addMetricsToSpecializedEquipment(
  data: SpecializedEquipment[],
  conditionedSpaceArea?: Area,
): SpecializedEquipmentWithMetrics[] {
  return addMetricsToResource(
    data,
    conditionedSpaceArea,
  ) as SpecializedEquipmentWithMetrics[];
}

export const useSportsArenaWithMetrics = (conditionedSpaceArea?: Area) => {
  return useQuery<
    SpecializedEquipment[],
    Error,
    SpecializedEquipmentWithMetrics[]
  >({
    queryKey: [
      'sportsarenaequipment',
      'withMetrics',
      conditionedSpaceArea?.value,
    ],
    queryFn: () =>
      apiFetch<SpecializedEquipment[]>(
        API_ENDPOINTS.COMMON.technology.sportsarenaequipment,
      ),
    enabled: conditionedSpaceArea !== undefined,
    select: (data) =>
      addMetricsToSpecializedEquipment(data, conditionedSpaceArea),
  });
};

export const useAbattoirWithMetrics = (conditionedSpaceArea?: Area) => {
  return useQuery<
    SpecializedEquipment[],
    Error,
    SpecializedEquipmentWithMetrics[]
  >({
    queryKey: ['abattoirequipment', 'withMetrics', conditionedSpaceArea?.value],
    queryFn: () =>
      apiFetch<SpecializedEquipment[]>(
        API_ENDPOINTS.COMMON.technology.abattoirequipment,
      ),
    enabled: conditionedSpaceArea !== undefined,
    select: (data) =>
      addMetricsToSpecializedEquipment(data, conditionedSpaceArea),
  });
};

export const useMedicalWithMetrics = (conditionedSpaceArea?: Area) => {
  return useQuery<
    SpecializedEquipment[],
    Error,
    SpecializedEquipmentWithMetrics[]
  >({
    queryKey: ['medicalequipment', 'withMetrics', conditionedSpaceArea?.value],
    queryFn: () =>
      apiFetch<SpecializedEquipment[]>(
        API_ENDPOINTS.COMMON.technology.medicalequipment,
      ),
    enabled: conditionedSpaceArea !== undefined,
    select: (data) =>
      addMetricsToSpecializedEquipment(data, conditionedSpaceArea),
  });
};
